import { Octokit } from '@octokit/rest';
import { extractGitHubInfo } from '../../../utils/helpers/extractGithubInfo.esm.js';

class GithubProvider {
  constructor(configApi) {
    this.configApi = configApi;
  }
  async getToken() {
    const token = this.configApi.getConfig("scaffolder")?.getConfig("providers").getConfigArray("github")?.[0]?.getOptionalString("token");
    return token || "";
  }
  async getOctokit(hostname) {
    const token = await this.getToken();
    return new Octokit({ auth: token, hostname });
  }
  //private async getListAlertsForRepo({owner,name}:RepoProps){
  //  const octokit = await this.getOctokit("github.com") //hardcoded
  //  return await octokit.rest.dependabot.listAlertsForRepo({
  //      owner: owner,
  //      repo: name
  //    });
  //}
  async getCodeScanningAlertsForRepo({ owner, name }) {
    const octokit = await this.getOctokit("github.com");
    return await octokit.rest.codeScanning.listAlertsForRepo({
      owner,
      repo: name
    });
  }
  async fetchVulnerabilitiesFromRepositoryList(_repos) {
    const results = [{
      repo: "veecode-homolog/demo-trivy",
      total: 4,
      critical: 1,
      high: 3,
      medium: 0,
      low: 0
    }];
    return results;
  }
  async fetchVulnerabititiesFromRepository(location) {
    const { owner, repo } = extractGitHubInfo(location);
    try {
      const alerts = await this.getCodeScanningAlertsForRepo({ owner, name: repo });
      const severityCount = {
        critical: 0,
        high: 0,
        medium: 0,
        low: 0
      };
      for (const alert of alerts.data) {
        const severity = alert.rule.security_severity_level?.toLowerCase();
        if (severity && severityCount.hasOwnProperty(severity)) {
          severityCount[severity]++;
        }
      }
      return {
        repo: `${owner}/${repo}`,
        total: alerts.data.length,
        ...severityCount
      };
    } catch (error) {
      console.error(`Error fetching alerts for ${repo}/${repo}:`, error);
      return null;
    }
  }
}

export { GithubProvider };
//# sourceMappingURL=GithubProvider.esm.js.map
